import { Component, inject, ChangeDetectorRef, ViewChild, AfterContentChecked, OnInit, AfterViewInit, signal } from "@angular/core"
import { take } from "rxjs"
import { NotificationService } from "../../common/services/notification.service"
import { BaseViewComponent } from "../base-view.component"
import { FormValidationService } from "../../common/services/form-validation.service"
import { StateChangedModel } from "../../common/services/state.service"
import { SecureDataService } from "../../common/services/securedata.sevice"
import { LanguageStateService } from "../../common/services/language-state.service"
import { CreditCardBillingComponent } from "../payment-information-entry/credit-card-billing/credit-card-billing.component"

//import { TranslationModule } from "../../common/modules/translation.module";

export enum OrderType {
  AIA = 'AIA',
  FIBER = 'FIBER'
}

@Component({
    selector: 'app-wireless-upgrade-payment',
    templateUrl: './wireless-upgrade-payment.component.html',
    styleUrl: './wireless-upgrade-payment.component.scss',
    standalone: false
})
export class WirelessUpgradePaymentComponent extends BaseViewComponent implements OnInit, AfterViewInit, AfterContentChecked {

  languageService: LanguageStateService = inject(LanguageStateService)
  protected override onSecureDataChanged(val: StateChangedModel): void {
    if (val.Type == 'upgradePaymentInformationEntry' && val.Data != undefined) {
      const rawData = val.Data;
      console.log('rawData', rawData);
      if (rawData && typeof rawData == 'object') {
        this.todaysChargesTotal.set(rawData['balance'])
        this.PaymentZipMustMatchService = rawData['PaymentZipMustMatchService'];
        this.paymentAllowAch = rawData['paymentAllowAch'];
        this.ServiceAvailabilityZipCode = rawData['ServiceAvailabilityZipCode'];
      }

    }
  }

  activeTabIndex = [0]
  showErrors = false
  orderType: string
  toastrService = inject(NotificationService)
  formValidationService = inject(FormValidationService)
  secureDataService = inject(SecureDataService)

  showCancelDialog = false

  cdr = inject(ChangeDetectorRef)
  todaysChargesTotal = signal(0)
  public termsAccepted = false


  @ViewChild('todayChargesCreditCardBilling')
  todayChargesCreditCardBillingComponent: CreditCardBillingComponent
  paymentErrorDialogTitle: string
  paymentErrorDialogVisible = false
  paymentErrorDialogMessage: string
  paymentAuthorizationDialog = false


  ServiceAvailabilityZipCode: string = ''
  PaymentZipMustMatchService = false
  autopayEnrollmentTermsUrl = ''
  paperlessEnrollmentTermsUrl = ''
  autopaySelection = false
  paymentAllowAch = false

  constructor() {
    super()
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(this.todayChargesCreditCardBillingComponent?.creditCardForm.valueChanges.subscribe(() => {

    }))
  }

  ngAfterContentChecked() {
    try {
      this.cdr.detectChanges()
    } catch {
      // Handle or log error if needed
    }
  }

  istodayChargesFormValid() {
    // If today's charges are 0, then form is automatically valid
    if (this.todaysChargesTotal() === 0) {
      return true
    }
    // Otherwise, check terms, credit card form validity AND card validation status
    return this.termsAccepted &&
      this.formValidationService.isFormValid(this.todayChargesCreditCardBillingComponent?.creditCardForm) &&
      this.todayChargesCreditCardBillingComponent?.isValidCard
  }

  onSubmitClicked() {
    this.showErrors = false
    if (!this.istodayChargesFormValid()) {
      this.todayChargesCreditCardBillingComponent?.creditCardForm.markAllAsTouched();
      this.formValidationService.validateForm(this.todayChargesCreditCardBillingComponent?.creditCardForm);
      this.showErrors = true
      return
    }

    const paymentDetails = this.buildPaymentDetails()
  


    if (this.todaysChargesTotal() === 0 && this.istodayChargesFormValid()) {
      return
    }

    const data = {
      paymentDetails,
    }

    this.secureDataService.submitCustomerData(data, 'upgradePaymentInformationEntry')
      .subscribe({
        next: () => {
          this.navigateWaiting();
        },
        error: (err) => {
          this.notificationService.showError(err);
        }
      });



  }

  onCancelClick() {
    this.showCancelDialog = true;
  }

  onCancel(data: unknown) {
    this.showCancelDialog = false;
    if (data && (data as { data: { success: boolean } }).data?.success) {
      this.subscriptions.add(this.secureDataService.cancel('PaymentInformationEntry-Cancel').pipe(take(1)).subscribe(
        {
          next: () => {
            this.navigateWaiting(true);
          },
          error: (err) => this.onCancelError('PaymentInformationEntry-Cancel', err)
        }))
    }
    // console.log(data);
  }


  private buildPaymentDetails() {
    const paymentDetails = []

    // Add today's charges payment details if amount > 0
    if (this.todaysChargesTotal() > 0) {
      paymentDetails.push(this.constructPaymentDetails(this.todayChargesCreditCardBillingComponent, 'today', this.todaysChargesTotal().toString()))
    }

    return paymentDetails
  }


  private constructPaymentDetails(creditCardComponent: CreditCardBillingComponent, payType, amount) {
    const form = creditCardComponent.creditCardForm
    const expirationDate = form.get('expirationDate')?.value
    const [expMonth, expYear] = expirationDate.split('/')

    return {
      PayType: payType,
      Service: "internet",
      Amount: amount,
      CreditCardType: creditCardComponent.cardType,
      CreditCardNumber: creditCardComponent.cardNumberRaw,
      CardHolderName: form.get('cardholderName')?.value,
      ExpirationMonth: expMonth,
      ExpirationYear: expYear,
      Cvv: creditCardComponent.cvvRaw,
      CardHolderZip: creditCardComponent.zipCodeRaw
    }
  }



}
